import React from 'react';
import { UserRole } from '@99designs/apps/spa/pages/auth/SSO/common/types';
import { Checkbox, CheckboxProps } from '@99designs/emu';

export type MarketingOptInCheckboxProps = {
    userRole: UserRole;
} & Omit<CheckboxProps, 'id' | 'label' | 'aria-label' | 'aria-labelledby'>;

export const MarketingOptInCheckbox = React.forwardRef<
    HTMLInputElement,
    MarketingOptInCheckboxProps
>(function ({ userRole, ...checkboxProps }, ref) {
    let label = __(
        'Sign me up for 99designs by Vista emails with design tips, brand inspiration, special offers & updates related to my account.'
    );

    if (userRole === 'designer') {
        label = __(
            'Sign me up for 99designs by Vista emails with helpful tips to get started, community news & updates related to my account.'
        );
    }

    return (
        <Checkbox
            data-testid="marketing-opt-in-checkbox"
            id="marketing-opt-in"
            label={label}
            ref={ref}
            {...checkboxProps}
        />
    );
});
